import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=53f28f05"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports